// Builder-Promo isolated JS entry (UI-only, jQuery-based).
// Compiled to public/js/builder-promo.js and loaded ONLY by the builder-promo layout.

global.$ = global.jQuery = require('jquery');
require('jquery-mask-plugin');

import { initModals } from './modal';
import { initDrawer } from './drawer';
import {
    initCreateStateMachine,
    initUpdateStateMachine,
    initCheckoutSteps,
    initPreviewToggle,
    initChoiceGroups,
    initPasswordChecks,
} from './state-machine';

// Image fallback per project rule:
// images live in /images/builder-promo; if missing, fall back to the shared placeholder.
function initImageFallback() {
    const FALLBACK = '/images/business_pages/previous-image-icon.png';
    document.querySelectorAll('img[data-bb-img]').forEach(function (img) {
        img.addEventListener('error', function handle() {
            img.removeEventListener('error', handle);
            if (img.src.indexOf(FALLBACK) === -1) img.src = FALLBACK;
        });
    });
}

$(function () {
    initModals();
    initDrawer();
    initChoiceGroups();
    initCheckoutSteps();
    initPreviewToggle();
    initPasswordChecks();
    initCreateStateMachine();
    initUpdateStateMachine();
    initImageFallback();
});
